import { render, staticRenderFns } from "./c_pictrue.vue?vue&type=template&id=6c40324f&scoped=true&"
import script from "./c_pictrue.vue?vue&type=script&lang=js&"
export * from "./c_pictrue.vue?vue&type=script&lang=js&"
import style0 from "./c_pictrue.vue?vue&type=style&index=0&id=6c40324f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40324f",
  null
  
)

export default component.exports